import React from 'react';
import { Typography } from 'fronton-react';
import { LoyaltyRegistartionBannerWrapper } from './styles';
import { MenyKeycards } from '../../../../../icons/menu-keycards';
import { useTranslation } from 'react-i18next';

export const LoyaltyRegistrationBanner: React.FC = () => {
  const { t } = useTranslation();

  return (
    <LoyaltyRegistartionBannerWrapper
      as="a"
      id="loyalty-registration-banner"
      data-qa="loyalty-registration-banner"
    >
      <Typography size="subtitle" variant="s">
        {t('header.main.user-menu.loyalty-registration-banner.get-points')}
      </Typography>
      <MenyKeycards />
    </LoyaltyRegistartionBannerWrapper>
  );
};
